import styled from 'styled-components';
import { SpinnerButton as WalrusSpinnerButton, ButtonProps, style } from '@do/walrus';
import vars from '../assets/overwrite-vars';
import { ButtonStyleProps } from './SharedStyles';

type SpinnerButtonProps = ButtonProps & {
  className?: string;
  spinning?: boolean;
  inline?: boolean;
  loadingMessage?: string;
  loadingMessageAlignment?: 'flex-start' | 'center';
};

type StyledButtonProps = SpinnerButtonProps & ButtonStyleProps;

const SpinnerButton = styled(WalrusSpinnerButton)<StyledButtonProps>(({ buttonStyle }) => ({
  '&&': {
    backgroundColor: buttonStyle?.bgColor,
    color: buttonStyle?.textColor,
    borderColor: buttonStyle?.borderColor,
    marginTop: style.vars.whitespace.medium,
    borderRadius: vars.border_radius_xlarge,

    '&:hover': {
      borderColor: buttonStyle?.hoverBorderColor,
      backgroundColor: buttonStyle?.hoverBgColor,
      color: buttonStyle?.hoverTextColor,
    },
  },
}));

export default SpinnerButton;
